/* eslint-disable react/prop-types */
import React from 'react';
import { PageTitle } from '@gsa/afp-component-library';
import RenewSolicitationForm from './renew-solicitation-form';
import UpiidDetailsFormContext from '../components/upiid-details/upiid-details-form-context';
import { useUpiidDetails } from '../components/upiid-details/upiid-details-provider';
import SolicitationStepper from '../components/solicitation-stepper';
import SolicitationNotification from '../utils/solicitation-notification';
import InactiveSIAlert from '../components/solicitation-alert/inactive-si-alert';

const RenewSolicitationContent = () => {
  const { solicitation, bidType } = useUpiidDetails();

  return (
    <div className="grid-col solicitation-upiid-details">
      <SolicitationNotification isModal={false} />

      <InactiveSIAlert
        solicitationPrograms={solicitation.programs}
        contractYear={solicitation.contractYear}
      />
      <PageTitle
        title={`Renew Solicitation - ${solicitation?.solicitationNumber}`}
      />
      <SolicitationStepper
        currentStep={1}
        solicitation={solicitation}
        currentBidType={bidType}
      />
      <UpiidDetailsFormContext solicitation={solicitation}>
        <RenewSolicitationForm />
      </UpiidDetailsFormContext>
    </div>
  );
};

export default RenewSolicitationContent;
